import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import TextArea from '../../../CommonV2/TextArea';

/**
 * FieldInput
 * @param {*} param0
 */
const FieldTextArea = ({ code, disabled, existError, showError, validate, handleBlur }) => (
  <Field
    component={TextArea}
    name={code}
    disabled={disabled}
    existError={existError}
    showError={showError}
    validate={validate}
    eventEmitter={v => handleBlur(v)}
  />
);

FieldTextArea.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
};
FieldTextArea.defaultProps = {
  disabled: false,
};

export default connect(FieldTextArea);
